export default __webpack_public_path__ + "static/media/solo-killer-bunnies.d0dd54f1.webp";